import * as con from './constants';
import { AnyAction } from 'redux';

const menuState = {
  menuRouteFilterId: '',
  collapsible: <Record<string, boolean>>{},
};

export const menu = (state = menuState, action: AnyAction): typeof menuState => {
  switch (action.type) {
    case con.MENU_ROUTE_FILTER_ID_SET: {
      const newState = {
        ...state,
        ...{
          menuRouteFilterId: action.payload,
        },
      };
      window.localStorage.setItem('menu', JSON.stringify(newState));
      return newState;
    }
    case con.MENU_ROUTE_INIT_COLLAPSIBLE: {
      const newState = {
        ...state,
        ...{
          collapsible: action.payload,
        },
      };
      window.localStorage.setItem('menu', JSON.stringify(newState));
      return newState;
    }
    case con.MENU_ROUTE_IS_COLLAPSIBLE_SET: {
      const newState = {
        ...state,
        ...{
          collapsible: {
            ...state.collapsible,
            [action.payload.id]: action.payload.isCollapsible,
          },
        },
      };
      window.localStorage.setItem('menu', JSON.stringify(newState));
      return newState;
    }
    default: {
      window.localStorage.setItem('menu', JSON.stringify(state));
      return state;
    }
  }
};
